import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, FreeMode } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/free-mode";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

function HotelSlider({ images }) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current) {
      setTimeout(() => {
        swiperRef.current.params.navigation.prevEl = prevRef.current;
        swiperRef.current.params.navigation.nextEl = nextRef.current;
        swiperRef.current.navigation.init();
        swiperRef.current.navigation.update();
      }, 100);
    }
  }, []);

  return (
    <div className="hotel-slider">
      {/* Custom Navigation Buttons */}
      <button ref={prevRef} className="custom-prev">
        <FaArrowLeft />
      </button>
      <button ref={nextRef} className="custom-next">
        <FaArrowRight />
      </button>

      {/* Thumbnails Slider */}
      <Swiper
        ref={swiperRef}
        modules={[Navigation, FreeMode]}
        slidesPerView={3}
        spaceBetween={10}
        freeMode={true}
        speed={500}
        navigation={{ prevEl: prevRef.current, nextEl: nextRef.current }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
        className="thumbs-slider"
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <img
              src={image}
              alt={`Thumbnail ${index + 1}`}
              className="thumbnail"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default HotelSlider;
